<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "AboutUsMobile"
}
</script>

<style scoped>

</style>